import React, { useState } from "react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../ui/popover";
import { cn } from "../../lib/utils";

// Tag that reveals explanatory text on hover (desktop) or click/tap (touch).
// When `info` is empty the tag renders as a plain, non-interactive pill.
// z-index sits above the Send Money drawer (z-[996]).
const TAG_BASE =
  "rounded px-2 py-0.5 text-[10px] font-geomanistBold uppercase tracking-wide bg-[#EBECEF] text-greyish";

function InfoTag({ label, info, className }) {
  const [open, setOpen] = useState(false);

  if (!info) {
    return <span className={cn(TAG_BASE, className)}>{label}</span>;
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
          onClick={(e) => e.stopPropagation()}
          className={cn(
            TAG_BASE,
            "cursor-pointer hover:bg-gray-200 focus:outline-none",
            className
          )}
        >
          {label}
        </button>
      </PopoverTrigger>
      <PopoverContent
        onOpenAutoFocus={(e) => e.preventDefault()}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onClick={(e) => e.stopPropagation()}
        className="z-[1000] w-64 p-3 rounded-lg border-0 bg-[#1F2430] text-white text-xs leading-5 font-geomanistRegular"
      >
        {info}
      </PopoverContent>
    </Popover>
  );
}

export default InfoTag;
